import React, { useEffect, useState } from "react";
import { Button } from "../../components/ui/button";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../../components/ui/accordion";
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "../../components/ui/avatar";
import { Checkbox } from "../../components/ui/checkbox";
import Helpers from "../../helpers";
import { scrollToTop } from "../../lib/utils";

const CategoryPage = () => {
  const [count, setCount] = useState<number>(0);

  useEffect(() => {
    scrollToTop()
  }, [])

  const increment = () => setCount(count + 1);
  const decrement = () => setCount(count > 0 ? count - 1 : 0);

  return (
    <div className="container-fluid bg-gray-100 mt-3">
      <div className="grid grid-cols-3 p-8">
        <div className="col-span-2">
          <div className="text-3xl ">Mon panier</div>

          <div className="w-21 mt-3 text-1xl">
            Vos produits proviennents des producteurs differents. Veuillez
            selectionner la premier commande a passer !!
          </div>

          <div className="mt-4 bg-white">
            <Accordion type="single" collapsible className="">
              <AccordionItem value="item-1">
                <AccordionTrigger>
                  <div className="flex-row flex ml-9">
                    <Avatar className="w-20 h-20">
                      <AvatarImage
                        src="../assets/female-09.png"
                        alt="@shadcn"
                      />
                      <AvatarFallback>CN</AvatarFallback>
                    </Avatar>
                    <div className="flex flex-col px-7 pt-4">
                      Olivier Didier
                      <span>Bertoua Cameroun</span>
                    </div>
                  </div>
                </AccordionTrigger>
                <AccordionContent>
                  <div
                    className="grid grid-cols-4 gap-x-3"
                    style={{ marginLeft: "10%", marginTop: "1%" }}
                  >
                    <div>
                      <div
                        className="flex items-center"
                        style={{ marginLeft: "30%", marginTop: '20%' }}
                      >
                        <Checkbox id="terms" />
                      </div>
                    </div>

                    <div>
                      {" "}
                      <img
                        alt="icon"
                        src="../assets/im1.jpg"
                        className="mr-2 h-[150px] w-[150px]"
                        style={{ borderRadius: "15px" }}
                      />
                    </div>

                    <div className="flex flex-col items-start gap-3">
                      <div>haricot</div>

                      <div>Variete: Haricot noir</div>

                      <div className="text-green-400">En stock: 400 sacs</div>

                      <div>Quantite min: 10</div>

                      <div className="bg-gray-200" style={{ borderRadius: '15px' }}>

                        <div className="flex items-center justify-center space-x-4">

                          <div className="text-gray-500">
                            Quantité
                          </div>
                          <button
                            onClick={decrement}
                            className=" text-black px-3 py-1 rounded-full "
                          >
                            -
                          </button>
                          <span className="text-1xl font-semibold">
                            {count}
                          </span>
                          <button
                            onClick={increment}
                            className="text-black px-3 py-1 rounded-full"
                          >
                            +
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="flex flex-col">
                      <div>Prix total:18000F</div>
                      <div className="" style={{ marginTop: "40%" }}>
                        <button type="button" className="text-red-500 hover:text-red-700 bg-transparent border-none cursor-pointer">
                          Lien en texte rouge
                        </button>
                      </div>
                    </div>
                  </div>
                </AccordionContent>
              </AccordionItem>

              <AccordionItem value="item-2">
                <AccordionTrigger>
                  <div className="flex-row flex ml-9">
                    <Avatar className="w-20 h-20">
                      <AvatarImage
                        src="../assets/male-17.png"
                        alt="@shadcn"
                      />
                      <AvatarFallback>CN</AvatarFallback>
                    </Avatar>
                    <div className="flex flex-col px-7 pt-4">
                      Olivier Didier
                      <span>Bertoua Cameroun</span>
                    </div>
                  </div>
                </AccordionTrigger>
                <AccordionContent>
                  <div
                    className="grid grid-cols-4 gap-x-3"
                    style={{ marginLeft: "10%", marginTop: "1%" }}
                  >
                    <div>
                      <div
                        className="flex items-center"
                        style={{ marginLeft: "30%", marginTop: '20%' }}
                      >
                        <Checkbox id="terms" />
                      </div>
                    </div>

                    <div>
                      {" "}
                      <img
                        alt="icon"
                        src="../assets/im1.jpg"
                        className="mr-2 h-[150px] w-[150px]"
                        style={{ borderRadius: "15px" }}
                      />
                    </div>

                    <div className="flex flex-col items-start gap-3">
                      <div>haricot</div>

                      <div>Variete: Haricot noir</div>

                      <div className="text-green-400">En stock: 400 sacs</div>

                      <div>Quantite min: 10</div>

                      <Helpers />
                    </div>

                    <div className="flex flex-col">
                      <div>Prix total:18000F</div>
                      <div className="" style={{ marginTop: "40%" }}>
                        <button className="text-red-500 hover:text-red-700">
                          Lien en texte rouge
                        </button>
                      </div>
                    </div>
                  </div>
                </AccordionContent>
              </AccordionItem>
            </Accordion>
          </div>
        </div>

        <div className="col-span-1">
          <div
            className="max-w-sm  h-[180px] rounded overflow-hidden shadow-lg bg-white p-4"
            style={{ marginLeft: "10%", marginTop: "16%" }}
          >
            <div className="mb-4">
              <h2 className="text-xl font-bold">Producteur: Sergeo Fouda</h2>
            </div>
            <div className="my-4">
              <p className="text-gray-700 text-base">
                prix total (1 produit) : $99.99
              </p>
            </div>
            <div className="flex justify-center mt-3">
              <Button
                className="bg-green-500 text-white p-2 rounded hover:bg-green-600 w-full"
                style={{ borderRadius: "50px", height: "2.5em" }}
              >
                Passer la Commande
              </Button>
            </div>
          </div>
        </div>
      </div>

      <div></div>
    </div>
  );
};

export default CategoryPage;
